import { User } from 'src/app/component/auth/model/user.model';
import { Region } from 'src/app/model/region.model';
import { StudentIdentifierOrganizations } from './../../../model/student-identifier-organizations.model';
import { Student } from 'src/app/model/student/student.model';
import { StudentIdentifierTypes } from './../../../model/student-identifier-types.model';
import { StudentIdentifierTypeService } from './../../../service/student-identifier-type.service';
import { StudentIdentifiers } from './../../../model/student-identifiers.model';
import { Component, EventEmitter, Input, OnInit, Output, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { TitleCasePipe } from '@angular/common';
import { FormGroupDirective, UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { StudentService } from '../../../service/student.service';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { HelperService } from 'src/app/service/helper.service';
import { TrackingHistoryService } from 'src/app/component/common-components/tracking-history/service/tracking-history.service';
import { UserProfileService } from 'src/app/component/user-profile/service/user-profile.service';
import { Subscription } from 'rxjs';
import { StudentHelperService } from '../../../service/student-helper.service';

@Component({
    selector: 'edit-child-demographic-identifiers',
    templateUrl: './edit-child-demographic-identifiers.component.html',
    styleUrls: ['./edit-child-demographic-identifiers.component.scss']
})
export class EditChildDemographicIdentifiersComponent implements OnInit {
    @Input() studentId!: number;
    @Input() editing: boolean;
    @Output() editingChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    msdNumber: string;

    @ViewChild('ssidForm') ssidForm: FormGroupDirective;
    @ViewChild('localIdForm') localIdForm: FormGroupDirective;
    ssidAddingForm!: UntypedFormGroup;
    ssidEditingForm!: UntypedFormGroup;
    ssidEditingId: number | undefined;
    localIdEditingForm!: UntypedFormGroup;
    localSchoolDistrict: SchoolDistrict | undefined;
    userRegion: Region;
    user: User;

    studentIdentifiers: StudentIdentifiers[] = [];
    studentIdentifierTypes: StudentIdentifierTypes[] = [];
    studentIdentifiersToCreate: StudentIdentifiers[] = [];
    studentIdentifiersToUpdate: StudentIdentifiers[] = [];
    studentIdentifiersToDelete: StudentIdentifiers[] = [];

    childIdentifiers: StudentIdentifiers[] = [];
    childIdentifiersBackup: StudentIdentifiers[] = [];
    localIdentifiers: StudentIdentifiers[] = [];
    localIdentifiersBackup: StudentIdentifiers[] = [];
    coeStarIdentifiers: StudentIdentifiers[] = [];
    coeStarIdentifiersBackup: StudentIdentifiers[] = [];

    ssidBackup: StudentIdentifiers | undefined;

    isLoading: boolean = false;
    isSaving: boolean = false;
    addingSSID: boolean = false;
    addingLocal: boolean = false;
    ssidFound: boolean = false;

    promises: Array<any> = [];

    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();

    // Table display
    newChildIdDisplayedColumns: string[] = ['ADD'];
    childIdDisplayedColumns: string[] = ['EDIT', 'STUDENT_IDENTIFIER_TYPES.TYPE', 'IDENTIFIER_VALUE'];
    newLocalDisplayedColumns: string[] = ['ADD'];
    localDisplayedColumns: string[] = ['EDIT', 'STUDENT_IDENTIFIER_ORGANIZATIONS[0].ORGANIZATION.NAME', 'IDENTIFIER_VALUE'];
    coeStarDisplayedColumns: string[] = ['STUDENT_IDENTIFIER_ORGANIZATIONS[0].ORGANIZATION.REGIONS[0].CODE', 'IDENTIFIER_VALUE'];

    // Table results
    childIdTableDataSource: MatTableDataSource<StudentIdentifiers>;
    localTableDataSource: MatTableDataSource<StudentIdentifiers>;
    coeStarTableDataSource: MatTableDataSource<StudentIdentifiers>;

    // Changes
    formChanges: any = {};

    getPropertyPipe = new GetPropertyPipe();

    subs: Subscription[] = [];

    constructor(
        private fb: UntypedFormBuilder,
        private studentService: StudentService,
        private studentIdentifierTypeService: StudentIdentifierTypeService,
        private helperService: HelperService,
        private userProfileService: UserProfileService,
        private trackingHistoryService: TrackingHistoryService,
        private studentHelper: StudentHelperService
    ) {
        this.ssidAddingForm = fb.group({
            idType: ['', [Validators.required]],
            identifierValue: ['', [Validators.required]]
        });
        this.ssidEditingForm = fb.group({
            idType: ['', [Validators.required]],
            identifierValue: ['', [Validators.required]]
        });
        this.localIdEditingForm = fb.group({
            identifierValue: ['', [Validators.required]]
        });
        this.subscriptions();
    }

    subscriptions() {
        let msdNumberSub = this.studentHelper.msdNumber$.subscribe((msdNumber) => {
            this.msdNumber = msdNumber;

            if (this.msdNumber) {
                Promise.all(this.promises).then((res) => {
                    let childIdentifiers = this.childIdentifiers.filter((id) => {
                        return id.STUDENT_IDENTIFIER_TYPES.TYPE !== 'MSDNumber' && id.STUDENT_IDENTIFIER_TYPES.TYPE !== 'MSD Number';
                    });

                    let msdNumbers = this.childIdentifiers.filter((id) => {
                        return (
                            (id.STUDENT_IDENTIFIER_TYPES.TYPE === 'MSDNumber' || id.STUDENT_IDENTIFIER_TYPES.TYPE === 'MSD Number') &&
                            id.IDENTIFIER_VALUE === this.msdNumber
                        );
                    });

                    this.childIdentifiers = childIdentifiers.concat(msdNumbers);

                    this.childIdentifiers = this.childIdentifiers.sort((a, b) =>
                        a.STUDENT_IDENTIFIER_TYPES.TYPE! > b.STUDENT_IDENTIFIER_TYPES.TYPE! ? 1 : -1
                    );

                    this.updateDataSource();
                });
            }
        });

        this.subs.push(msdNumberSub);
    }

    ngOnDestroy(): void {
        this.subs.forEach((sub) => {
            sub.unsubscribe();
        });
    }

    ngOnInit(): void {}

    init() {
        this.isLoading = true;
        this.studentIdentifiersToCreate = [];
        this.studentIdentifiersToUpdate = [];
        this.studentIdentifiersToDelete = [];
        this.cancelEditLocal();
        this.cancelEditSSID();

        this.getStudentIdentifiers();
        this.getStudentIdentifierTypes();
        this.getUserRegion();
        this.getUserProfile();
        Promise.all(this.promises).then((res) => {
            this.updateDataSource();

            this.initCurrentChanges();
            this.setCurrentChanges();

            this.isLoading = false;
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.editing) {
            this.childIdDisplayedColumns = ['EDIT', 'STUDENT_IDENTIFIER_TYPES.TYPE', 'IDENTIFIER_VALUE'];
            this.localDisplayedColumns = ['EDIT', 'STUDENT_IDENTIFIER_ORGANIZATIONS[0].ORGANIZATION.NAME', 'IDENTIFIER_VALUE'];
            this.newChildIdDisplayedColumns = ['ADD'];
            this.newLocalDisplayedColumns = ['ADD'];
            this.ssidEditingForm.enable();
            this.localIdEditingForm.enable();
        } else {
            this.childIdDisplayedColumns = ['STUDENT_IDENTIFIER_TYPES.TYPE', 'IDENTIFIER_VALUE'];
            this.localDisplayedColumns = ['STUDENT_IDENTIFIER_ORGANIZATIONS[0].ORGANIZATION.NAME', 'IDENTIFIER_VALUE'];
            this.newChildIdDisplayedColumns = [];
            this.newLocalDisplayedColumns = [];
            this.ssidEditingForm.disable();
            this.localIdEditingForm.disable();
            if (changes['editing']) {
                this.init();
            }
        }
    }

    getStudentIdentifiers() {
        let deferred = new Promise((resolve, reject) => {
            this.studentService.getIdentifiers(this.studentId).subscribe((res) => {
                if (res.identifiers) {
                    this.studentIdentifiers = res.identifiers;

                    this.studentIdentifiers.forEach((si) => {
                        switch (si.STUDENT_IDENTIFIER_TYPES.TYPE) {
                            case 'MSDNumber':
                                si.STUDENT_IDENTIFIER_TYPES.TYPE = 'MSD Number';
                                break;
                            case 'MSIXNumber':
                                si.STUDENT_IDENTIFIER_TYPES.TYPE = 'MSIX Number';
                                break;
                            case 'California State Student ID':
                                si.STUDENT_IDENTIFIER_TYPES.TYPE = 'SSID Number';
                                break;
                            default:
                                break;
                        }
                    });

                    this.childIdentifiers = [];
                    this.localIdentifiers = [];
                    this.coeStarIdentifiers = [];

                    this.studentIdentifiers.forEach((studentIdentifier) => {
                        switch (studentIdentifier.STUDENT_IDENTIFIER_TYPES.TYPE) {
                            case 'MSDNumber':
                            case 'MSD Number':
                                // Handle duplicate MSD Numbers
                                this.childIdentifiers.findIndex((ci) => ci.IDENTIFIER_VALUE === studentIdentifier.IDENTIFIER_VALUE) < 0
                                    ? this.childIdentifiers.push(studentIdentifier)
                                    : null;
                                break;
                            case 'MSIXNumber':
                            case 'MSIX Number':
                                this.childIdentifiers.push(studentIdentifier);
                                break;
                            case 'California State Student ID':
                            case 'SSID Number':
                                this.childIdentifiers.push(studentIdentifier);
                                this.setSsidFound(true);
                                break;
                            case 'SCHOOL_DISTRICT_ID':
                            case 'DUES':
                            case 'DHS':
                            case 'Student_ID':
                            case '061062166':
                            case '063066670':
                            case '063768098':
                            case '063768452':
                            case '063773551':
                            case '063773791':
                            case '063775614':
                            case '064369666':
                            case '064269120':
                                this.localIdentifiers.push(studentIdentifier);
                                break;
                            case 'COEStar_Number':
                                this.coeStarIdentifiers.push(studentIdentifier);
                                break;
                            default:
                                break;
                        }
                    });

                    this.childIdentifiersBackup = JSON.parse(JSON.stringify(this.childIdentifiers));
                    this.localIdentifiersBackup = JSON.parse(JSON.stringify(this.localIdentifiers));
                    this.coeStarIdentifiersBackup = JSON.parse(JSON.stringify(this.coeStarIdentifiers));

                    resolve(res);
                } else if (res?.msg) {
                    reject(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    getStudentIdentifierTypes() {
        let deferred = new Promise((resolve, reject) => {
            this.studentIdentifierTypeService.getIdentifierTypes().subscribe((res) => {
                if (res.identifierTypes) {
                    this.studentIdentifierTypes = res.identifierTypes;

                    this.studentIdentifierTypes.forEach((sit) => {
                        switch (sit.TYPE) {
                            case 'MSDNumber':
                                sit.TYPE = 'MSD Number';
                                break;
                            case 'MSIXNumber':
                                sit.TYPE = 'MSIX Number';
                                break;
                            case 'California State Student ID':
                                sit.TYPE = 'SSID Number';
                                break;
                            default:
                                break;
                        }
                    });

                    resolve(res);
                } else if (res?.msg) {
                    reject(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    getUserRegion() {
        this.helperService.lstUserProfileRegion$.subscribe((userRegion: Region[]) => {
            this.helperService.setSelectedRegionObject(userRegion);
        });
    }

    getUserProfile() {
        let deferred = new Promise((resolve, reject) => {
            this.userProfileService.getMyProfile().subscribe((res) => {
                if (res?.user) {
                    this.user = res.user;

                    resolve(res);
                } else if (res?.msg) {
                    reject(res);
                } else {
                    reject('err');
                }
            });
        });
        this.promises.push(deferred);
    }

    submit() {
        if (this.ssidEditingId || this.addingSSID || this.addingLocal) {
            return new Promise((resolve, reject) => {
                reject({ MSG: 'Please finish editing Identifiers.', SUCCESS: false });
            });
        } else if (this.studentIdentifiersToCreate.length > 0 || this.studentIdentifiersToUpdate.length > 0 || this.studentIdentifiersToDelete.length > 0) {
            this.isSaving = true;
            this.promises = [];

            this.studentIdentifiersToCreate.forEach((studentIdentifier) => {
                this.createStudentIdentifier(studentIdentifier);
            });

            this.studentIdentifiersToUpdate.forEach((studentIdentifier) => {
                this.updateStudentIdentifier(studentIdentifier);
            });

            this.studentIdentifiersToDelete.forEach((studentIdentifier) => {
                this.deleteStudentIdentifier(studentIdentifier);
            });

            //this.createTrackingHistory();

            return new Promise((resolve, reject) => {
                Promise.all(this.promises).then(
                    (res) => {
                        this.ngOnInit();
                        this.isSaving = false;
                        resolve({ MSG: 'Child Identifiers succcessfuly updated.', SUCCESS: true });
                    },
                    (err) => {
                        this.isSaving = false;
                        reject({ MSG: 'Child Identifiers has errors.', SUCCESS: false });
                    }
                );
            });
        } else {
            return new Promise((resolve, reject) => {
                resolve({});
            });
        }
    }

    createStudentIdentifier(studentIdentifier: StudentIdentifiers) {
        let deferred = new Promise((resolve, reject) => {
            this.studentService
                .createStudentIdentifier(
                    this.studentId,
                    studentIdentifier.STUDENT_IDENTIFIER_TYPES.ID,
                    studentIdentifier.IDENTIFIER_VALUE,
                    studentIdentifier.STUDENT_IDENTIFIER_ORGANIZATIONS ? studentIdentifier.STUDENT_IDENTIFIER_ORGANIZATIONS[0].ORGANIZATION.ID : undefined
                )
                .subscribe((res) => {
                    if (res?.msg) {
                        if (res.msg.SUCCESS) {
                            resolve(res);
                        } else {
                            reject(res);
                        }
                    } else {
                        reject('err');
                    }
                });
        });

        this.promises.push(deferred);
    }

    updateStudentIdentifier(studentIdentifier: StudentIdentifiers) {
        let deferred = new Promise((resolve, reject) => {
            this.studentService.updateStudentIdentifier(<Student>{ ID: this.studentId }, studentIdentifier).subscribe((res) => {
                if (res?.msg) {
                    if (res.msg.SUCCESS) {
                        resolve(res);
                    } else {
                        reject(res);
                    }
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    deleteStudentIdentifier(studentIdentifier: StudentIdentifiers) {
        let deferred = new Promise((resolve, reject) => {
            this.studentService.deleteStudentIdentifier(studentIdentifier.ID).subscribe((res) => {
                if (res?.msg) {
                    if (res.msg.SUCCESS) {
                        resolve(res);
                    } else {
                        reject(res);
                    }
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    createTrackingHistory() {
        let deferred = new Promise((resolve, reject) => {
            let payload = this.getTrackingHistories();

            if (payload.editedFields.length > 0) {
                this.trackingHistoryService.create(payload).subscribe((res) => {
                    resolve(res);
                });
            } else {
                resolve({});
            }
        });

        this.promises.push(deferred);
    }

    updateDataSource() {
        setTimeout(() => {
            // Data
            let dataSource = new MatTableDataSource<StudentIdentifiers>();
            dataSource.data = this.fillEmptySSID(this.childIdentifiers);

            console.warn(dataSource.data);

            this.childIdTableDataSource = dataSource;
        });
        setTimeout(() => {
            // Data
            let dataSource = new MatTableDataSource<StudentIdentifiers>();
            dataSource.data = this.localIdentifiers;

            this.localTableDataSource = dataSource;
        });
        setTimeout(() => {
            // Data
            let dataSource = new MatTableDataSource<StudentIdentifiers>();
            dataSource.data = this.coeStarIdentifiers;

            this.coeStarTableDataSource = dataSource;
        });
    }

    private setSsidFound(found: boolean) {
        if (found) {
            this.ssidFound = found;
        } else {
            this.ssidFound = found;
        }
    }

    private fillEmptySSID(studentIdentifers: StudentIdentifiers[]) {
        let foundIndex = studentIdentifers.findIndex(
            (si) => si.STUDENT_IDENTIFIER_TYPES?.TYPE === 'California State Student ID' || si.STUDENT_IDENTIFIER_TYPES?.TYPE === 'SSID Number'
        );

        if (foundIndex >= 0) return studentIdentifers;

        let ssidIdType = this.studentIdentifierTypes.find((si) => si.TYPE === 'California State Student ID' || si.TYPE === 'SSID Number');

        if (ssidIdType) {
            let emptySSID = new StudentIdentifiers();
            emptySSID.ID = 0;
            emptySSID.STUDENT_IDENTIFIER_TYPES = ssidIdType;
            emptySSID.STUDENT_IDENTIFIER_TYPES_ID = ssidIdType.ID;
            studentIdentifers.push(emptySSID);

            this.setSsidFound(false);

            return studentIdentifers;
        } else {
            return studentIdentifers;
        }
    }

    // *********************** SSID Editing ***********************
    // Edit Function
    addSSID() {
        this.newChildIdDisplayedColumns = ['ADD_EDIT', 'ADD_STUDENT_IDENTIFIER_TYPES.TYPE', 'ADD_IDENTIFIER_VALUE'];
        let ssidIdType = this.studentIdentifierTypes.find((si) => si.TYPE === 'California State Student ID' || si.TYPE === 'SSID Number');
        this.ssidAddingForm.patchValue({ idType: ssidIdType, identifierValue: '' });
        this.addingSSID = true;
    }
    confirmAddSSID() {
        this._confirmAddSSID(this.ssidAddingForm);
        this.updateDataSource();
        this.setSsidFound(true);
        this._cancelEditSSID();
    }
    editSSID(studentIdentifier: StudentIdentifiers) {
        this._setEditingSSID(studentIdentifier);
    }
    confirmEditSSID() {
        this._confirmEditSSID(this.ssidEditingForm);
        this.updateDataSource();
        this._cancelEditSSID();
    }
    cancelEditSSID() {
        this._cancelEditSSID();
    }
    deleteSSID(studentIdentifier: StudentIdentifiers) {
        this._confirmDeleteSSID(studentIdentifier);
        this.updateDataSource();
        this.setSsidFound(false);
    }

    private _cancelEditSSID() {
        this._resetEditingSSID();
    }

    private _setEditingSSID(studentIdentifier: StudentIdentifiers) {
        this.ssidEditingId = studentIdentifier.ID;
        this.ssidEditingForm.patchValue({
            idType: this.studentIdentifierTypes.find((sit) => sit.TYPE === studentIdentifier.STUDENT_IDENTIFIER_TYPES.TYPE),
            identifierValue: studentIdentifier.IDENTIFIER_VALUE
        });
        this.ssidEditingForm.markAsPristine();

        this.ssidBackup = JSON.parse(JSON.stringify(studentIdentifier));
    }

    private _resetEditingSSID() {
        this.ssidEditingForm.patchValue({ idType: '', identifierValue: '' });
        this.ssidEditingId = undefined;
        this.ssidBackup = undefined;

        if (this.editing) {
            this.newChildIdDisplayedColumns = ['ADD'];
        } else {
            this.newChildIdDisplayedColumns = [];
        }
        this.addingSSID = false;
    }

    private _confirmEditSSID(form: UntypedFormGroup) {
        if (form.valid) {
            if (this.ssidBackup && form.get('identifierValue')?.value !== this.ssidBackup?.IDENTIFIER_VALUE) {
                let newEdit = this.ssidBackup;
                newEdit.IDENTIFIER_VALUE = form.get('identifierValue')?.value;

                let index = this.studentIdentifiersToUpdate.findIndex((si) => si.ID === newEdit.ID);

                if (index >= 0) {
                    this.studentIdentifiersToUpdate[index] = newEdit;
                } else {
                    this.studentIdentifiersToUpdate.push(newEdit);
                }

                index = this.childIdentifiers.findIndex((si) => si.ID === newEdit.ID);
                this.childIdentifiers[index].IDENTIFIER_VALUE = newEdit.IDENTIFIER_VALUE;
            }
        }
    }

    private _confirmAddSSID(form: UntypedFormGroup) {
        if (form.valid) {
            // Try to find ID from studentIdentifiersToDelete to update
            let index: number;
            index = this.studentIdentifiersToDelete.findIndex((si) => si.STUDENT_IDENTIFIER_TYPES.TYPE === form.get('idType')?.value.TYPE);

            let newEdit = new StudentIdentifiers();
            newEdit.ID = index >= 0 ? this.studentIdentifiersToDelete[index].ID : 0;
            newEdit.STUDENT_IDENTIFIER_TYPES = form.get('idType')?.value;
            newEdit.IDENTIFIER_VALUE = form.get('identifierValue')?.value;

            const ssidIndex = this.childIdentifiers.findIndex((x) => x.ID === 0);

            if (ssidIndex !== -1) {
                this.childIdentifiers[ssidIndex] = { ...this.childIdentifiers[ssidIndex], ...newEdit };
            }

            this.studentIdentifiersToUpdate.push(newEdit);

            //this.childIdentifiers.push(newEdit);

            if (index < 0) {
                this.studentIdentifiersToDelete.splice(index, 1);
            }
        }
    }

    private _confirmDeleteSSID(studentIdentifier: StudentIdentifiers) {
        let index: number;
        if (studentIdentifier.ID > 0) {
            index = this.studentIdentifiersToDelete.findIndex((si) => si.ID === studentIdentifier.ID);

            if (index < 0) {
                this.studentIdentifiersToDelete.push(studentIdentifier);
            }
        }
        index = this.childIdentifiers.findIndex((si) => si.ID === studentIdentifier.ID);

        if (index >= 0) {
            this.childIdentifiers.splice(index, 1);
        }

        index = this.studentIdentifiersToCreate.findIndex((si) => si.ID === studentIdentifier.ID);

        if (index >= 0) {
            this.studentIdentifiersToCreate.splice(index, 1);
        }

        index = this.studentIdentifiersToUpdate.findIndex((si) => si.ID === studentIdentifier.ID);

        if (index >= 0) {
            this.studentIdentifiersToUpdate.splice(index, 1);
        }
    }

    // *********************** SSID Editing End *******************

    // *********************** Local IDs Editing ***********************
    districtsSelected(districts: SchoolDistrict[]) {
        if (districts && districts.length > 0) {
            this.localSchoolDistrict = districts[0];
        } else {
            this.localSchoolDistrict = undefined;
        }
    }

    // Edit Function
    addLocal() {
        this.newLocalDisplayedColumns = ['ADD_EDIT', 'ADD_SCHOOL_DISTRICT', 'ADD_IDENTIFIER_VALUE'];
        this.localIdEditingForm.patchValue({ identifierValue: '' });
        this.addingLocal = true;
    }
    confirmAddLocal() {
        this._confirmAddLocal(this.localIdEditingForm);
        this.updateDataSource();
        this._cancelEditLocal();
    }
    cancelEditLocal() {
        this._cancelEditLocal();
    }
    deleteLocal(studentIdentifier: StudentIdentifiers) {
        this._confirmDeleteLocal(studentIdentifier);
        this.updateDataSource();
    }

    private _cancelEditLocal() {
        this._resetEditingLocal();
    }
    private _resetEditingLocal() {
        this.localIdEditingForm.patchValue({ identifierValue: '' });

        if (this.editing) {
            this.newLocalDisplayedColumns = ['ADD'];
        } else {
            this.newLocalDisplayedColumns = [];
        }
        this.addingLocal = false;
    }

    private _confirmAddLocal(form: UntypedFormGroup) {
        if (form.valid) {
            let ssidIdType = this.studentIdentifierTypes.find((si) => si.TYPE === 'SCHOOL_DISTRICT_ID');
            let siOrganization: StudentIdentifierOrganizations = new StudentIdentifierOrganizations();
            siOrganization.ORGANIZATION = this.localSchoolDistrict!.ORGANIZATION;
            siOrganization.ORGANIZATIONS_ID = this.localSchoolDistrict!.ORGANIZATION.ID;

            let newEdit = new StudentIdentifiers();
            newEdit.ID = 0;
            newEdit.STUDENT_IDENTIFIER_TYPES = ssidIdType!;
            newEdit.IDENTIFIER_VALUE = form.get('identifierValue')?.value;
            newEdit.STUDENT_IDENTIFIER_ORGANIZATIONS = [siOrganization];

            this.studentIdentifiersToCreate.push(newEdit);

            this.localIdentifiers.push(newEdit);
        }
    }

    private _confirmDeleteLocal(studentIdentifier: StudentIdentifiers) {
        let index: number;
        if (studentIdentifier.ID > 0) {
            index = this.studentIdentifiersToDelete.findIndex((si) => si.ID === studentIdentifier.ID);

            if (index < 0) {
                this.studentIdentifiersToDelete.push(studentIdentifier);
            }
        }
        index = this.localIdentifiers.findIndex((si) => si.ID === studentIdentifier.ID);

        if (index >= 0) {
            this.localIdentifiers.splice(index, 1);
        }

        index = this.studentIdentifiersToCreate.findIndex((si) => si.ID === studentIdentifier.ID);

        if (index >= 0) {
            this.studentIdentifiersToCreate.splice(index, 1);
        }
    }

    // *********************** Local IDs Editing End *******************

    initCurrentChanges() {
        // Existing
        this.childIdentifiers.forEach((id) => {
            this.formChanges[id.STUDENT_IDENTIFIER_TYPES.TYPE] = {
                CHANGED_FIELD: id.STUDENT_IDENTIFIER_TYPES.TYPE,
                VALUE: '',
                CHANGED_VALUE: '',
                ID: id.ID
            };
        });

        // Check if SSID exists
        if (!this.formChanges['SSID Number']) {
            this.formChanges['SSID Number'] = {
                CHANGED_FIELD: 'SSID Number',
                VALUE: '',
                CHANGED_VALUE: ''
            };
        }
    }

    setCurrentChanges() {
        // Existing
        this.childIdentifiers.forEach((id) => {
            this.formChanges[id.STUDENT_IDENTIFIER_TYPES.TYPE].VALUE = id.IDENTIFIER_VALUE === null ? '' : id.IDENTIFIER_VALUE;
        });

        // Set same value
        Object.keys(this.formChanges).forEach((key) => {
            this.formChanges[key].CHANGED_VALUE = this.formChanges[key].VALUE;
        });
    }

    updateChanges() {
        let ssidFormChange: any;

        Object.keys(this.formChanges).forEach((key) => {
            if (this.formChanges['SSID Number']) {
                ssidFormChange = JSON.parse(JSON.stringify(this.formChanges['SSID Number']));
            }
        });

        this.formChanges = {};

        if (ssidFormChange) {
            this.formChanges['SSID Number'] = ssidFormChange;
        }

        this.studentIdentifiersToCreate.forEach((studentIdentifier, index) => {
            if (studentIdentifier.STUDENT_IDENTIFIER_TYPES.TYPE !== 'SSID Number') {
                this.formChanges['C_' + studentIdentifier.STUDENT_IDENTIFIER_TYPES.TYPE + index.toString()] = {
                    CHANGED_FIELD: 'New Local SIS ID',
                    VALUE: '',
                    CHANGED_VALUE: studentIdentifier.IDENTIFIER_VALUE
                };
            } else {
                this.formChanges[studentIdentifier.STUDENT_IDENTIFIER_TYPES.TYPE].CHANGED_VALUE = studentIdentifier.IDENTIFIER_VALUE;
            }
        });

        this.studentIdentifiersToUpdate.forEach((studentIdentifier) => {
            if (studentIdentifier.STUDENT_IDENTIFIER_TYPES.TYPE !== 'SSID Number') {
                //
            } else {
                this.formChanges[studentIdentifier.STUDENT_IDENTIFIER_TYPES.TYPE].CHANGED_VALUE = studentIdentifier.IDENTIFIER_VALUE;
            }
        });

        this.studentIdentifiersToDelete.forEach((studentIdentifier, index) => {
            if (studentIdentifier.STUDENT_IDENTIFIER_TYPES.TYPE !== 'SSID Number') {
                this.formChanges['D_' + studentIdentifier.STUDENT_IDENTIFIER_TYPES.TYPE + index.toString()] = {
                    CHANGED_FIELD: 'Delete Local SIS ID',
                    VALUE: studentIdentifier.IDENTIFIER_VALUE,
                    CHANGED_VALUE: ''
                };
            } else {
                this.formChanges[studentIdentifier.STUDENT_IDENTIFIER_TYPES.TYPE].CHANGED_VALUE = '';
            }
        });

        Object.keys(this.formChanges).forEach((key) => {
            this.formChanges[key].CHANGED = this.formChanges[key].VALUE !== this.formChanges[key].CHANGED_VALUE;
        });
    }

    getChanges() {
        this.updateChanges();
        let changes: any[] = [];

        Object.keys(this.formChanges).forEach((key) => {
            if (this.formChanges[key].CHANGED) {
                changes.push(this.formChanges[key]);
            }
        });

        return changes;
    }

    getTrackingHistories() {
        let trackingHistories: any[] = [];

        Object.keys(this.formChanges).forEach((key) => {
            if (this.formChanges[key].CHANGED) {
                let trackingHistory = this.formChanges[key];
                trackingHistory.CHANGED_BY = this.user.USER_ID;
                trackingHistory.CHANGED_FORM = 'Student Identifiers';
                trackingHistory.CHANGED_FORM_ID = this.studentId;
                trackingHistory.CHANGED_VALUE = trackingHistory.VALUE; // VALUE holds current value, CHANGED_VALUE is used in back-end to record previous data.

                trackingHistories.push(trackingHistory);
            }
        });

        return { editedFields: trackingHistories };
    }
}
